import React from "react";
import "./container.css";

function ContentContainer(props) {
  // console.log(props);
  return <div className="content-container">{props.children}</div>;
}
export default ContentContainer;
